import * as React from 'react';
import axios from 'axios';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import 'react-bootstrap-typeahead/css/Typeahead-bs4.css';

export default class ActivitiesAutocomplete extends React.Component<any, any> {
  private URL = process.env.REACT_APP_ACTIVITIES_URL;
  private ref: any = React.createRef();

  constructor(props: any) {
    super(props);

    this.state = {
      options: [],
      isLoading: false,
    };

    this.request = this.request.bind(this);
  }

  public render() {
    return (
      <AsyncTypeahead
        options={this.state.options}
        isLoading={this.state.isLoading}
        labelKey="name"
        ref={(ref: any) => this.ref = ref}
        renderMenuItemChildren={(option: any) => {
          return (
            <div key={`${option.id}`}>
              #{option.id} - {option.name}
            </div>
          );
        }}
        onChange={(selected: any) => {
          if (!selected.length) {
            return;
          }

          const [item] = selected;
          this.props.onSelected({
            ...item,
            short_description: item.short_description || '',
            images: item.images || [],
          });

          this.ref.getInstance().clear();
        }}
        minLength={3}
        onSearch={this.request}
        emptyLabel="Sin resultados"
      />
    );
  }

  private async request(query: string): Promise<any> {
    console.log(`Fetch ${query}`);
    this.setState({ isLoading: true });

    const options: any = {
      method: 'GET',
      url: `${this.URL}/api/services/autocomplete`,
      params: {
        where: {
          name: { $like: `${query}%` },
        },
      },
    };

    const { data } = await axios(options);

    this.setState({ options: data, isLoading: false });
  }
}



// WEBPACK FOOTER //
// ./src/containers/Shared/ActivitiesAutocomplete.tsx